<template>
	<v-layout row wrap>
		<v-flex sm12 md6>
			<p class="add-event-step-header mb-0">Where will the event take place?</p>
			<p class="add-event-step-sub-header">Select from your existing locations, or <a @click="newLocation">create a new location</a>.</p>
			<v-combobox
				v-if="getMyLocations"
				:height="64"
				chips
				type="select"
				color="link"
				:items="getMyLocations"
				v-model="selectedLocation"
				placeholder="Select a Location"
				open-on-clear
				item-text="name"
				return-object
			>
				<template slot="selection" slot-scope="data">
					<!-- <v-chip
						@input="data.parent.selectItem(data.item)"
						:selected="data.selected"
					> -->
						<v-avatar size="48">
							<img :src="data.item.primary_image.image">
						</v-avatar>
						<span class="ml-3" style="color: #000;">
							{{ data.item.name }}
						</span>
					<!-- </v-chip> -->
				</template>
				<template slot="item" slot-scope="data">
						<v-list-tile-avatar>
							<img :src="data.item.primary_image.image"/>
						</v-list-tile-avatar>
						<v-list-tile-content class="ml-3">
							<v-list-tile-title v-html="data.item.name"></v-list-tile-title>
						</v-list-tile-content>
				</template>
			</v-combobox>
		</v-flex>
		<v-flex md4 offset-md1 hidden-sm-and-down class="pt-3">
			<v-card class="add-event-tip-box">
				<v-card-text class="p-relative pt-5">
					<div class="info-trapezoid p-absolute">
						<div class="info-content">
							<img src="/static/images/icon/light-bulb-gray.svg" width="40" />
						</div>
					</div>
					<p class="add-event-example-sub-header">Save Time</p>
					<p class="add-event-example-content">Selecting your location pre-fills location-specific event information, such as amenities.</p>
					<p class="add-event-example-content">If this event is happening in a new spot, please <a @click="newLocation">create a new location</a> first.</p>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-dialog scrollable v-model="infoDialog">
			<v-card style="width: 100%">
				<v-card-title class="mb-0 pb-2 pt-3">
					<img class="info-mobile-icon" src="/static/images/icon/light-bulb-gray.svg" />
				</v-card-title>
				<v-card-text style="max-height:50vh;">
					<p class="add-event-example-sub-header">Save Time</p>
					<p class="add-event-example-content">Selecting your location pre-fills location-specific event information, such as amenities.</p>
					<p class="add-event-example-content">If this event is happening in a new spot, please <a @click="newLocation">create a new location</a> first.</p>
				</v-card-text>
				<v-card-actions>
					<v-spacer>
					</v-spacer>
					<v-btn icon class="info-mobile-dialog-close-button" @click="infoDialog=false"><v-icon>close</v-icon></v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { deepCopy } from '~/store/util/util'
import { fetchAllLocations } from '~/store/api/event_location_api'
export default {
	data() {
		return {
			location: null,
			setLocation: false,
		}
	},
	beforeRouteLeave(to, from, next) {
		if (this.getAddEventProp('location') !== null) {
			this.setAddEventValidStep(from.path)
			this.removeAddEventInvalidStep(from.path)
		} else {
			this.setAddEventInvalidStep(from.path)
		}
		next()
	},
	created() {
		fetchAllLocations().then((response) => {
			let locations = response.data
			let params = window.location.search.slice(1).split(/[\?\&]+/)
			for (let param in params) {
				let prop = params[param].split('=')[0]
				let value = params[param].split('=')[1]
				if (prop === 'location') {
					let temp = locations.find((location) => {
						return location.pk == parseInt(value)
					})
					this.selectedLocation = temp
					this.location = this.selectedLocation
				}
			}
		})
	},
	methods: {
		...mapActions([
			'setAllLocations',
			'setAddEventProp',
			'setAddEventValidStep',
			'setAddEventInvalidStep',
			'removeAddEventInvalidStep',
			'addLocationResetState',
			'removeAddEventValidStep'
		]),
		newLocation() {
			this.addLocationResetState()
			this.$router.push('/host/add/location')
		}
	},
	computed: {
		...mapGetters([
			'getMyLocations',
			'getAddEventProp',
			'getAddLocationProp',
			'getLocation'
		]),
		selectedLocation: {
			get() {
				return this.getAddEventProp('location')
			},
			set(location) {
				let val = location.pk
				this.setAddEventProp({
					prop: 'location',
					value: location
				})
				// set event creation store parameters based on location parameters
				// let loc = this.getLocation(location.pk)
				if (location.location_rules !== null) {
					this.setAddEventProp({ prop: 'rules', value: location.location_rules })
				}
				if (location.max_attendees !== null) {
					this.setAddEventProp({ prop: 'seats', value: location.max_attendees })
					this.setAddEventProp({ prop: 'maxSeats', value: location.max_attendees })
				}
				let images = []
				let imageObjs = []
				images.push(location.primary_image.pk)
				imageObjs.push({
					name: location.primary_image.filename,
					image: location.primary_image.image,
					pk: location.primary_image.pk,
					filesize: 1,
					locationImage: true
				})

				for (var e = 0; e < location.additional_images.length; e++) {
					images.push(location.additional_images[e].pk)
					imageObjs.push({
						name: location.additional_images[e].filename,
						image: location.additional_images[e].image,
						pk: location.additional_images[e].pk,
						filesize: 1,
						locationImage: true
					})
				}
				if (images !== []) {
					this.setAddEventProp({ prop: 'images', value: images })
				}
				if (imageObjs !== []) {
					this.setAddEventProp({ prop: 'imageObjs', value: imageObjs })
				}
				this.setAddEventProp({
					prop: 'primaryImage',
					value: location.primary_image.pk
				})

				this.setAddEventProp({
					prop: 'locationInfo',
					value: location.provisions.provisions
				})
				this.setAddEventProp({
					prop: 'locationInfoInputs',
					value: location.provisions.inputs
				})

				let provisions = location.provisions.provisions
				if (provisions) {
					if (provisions.includes('free_on_premises')) {
						this.setAddEventProp({ prop: 'freeParking', value: true })
						if (
							location.provisions.inputs.hasOwnProperty('free_on_premises_input')
						) {
							this.setAddEventProp({
								prop: 'freeParkingText',
								value: location.provisions.inputs.free_on_premises_input
							})
						}
					}
					if (provisions.includes('street_parking')) {
						this.setAddEventProp({ prop: 'streetParking', value: true })
						if (location.provisions.inputs.hasOwnProperty('street_parking_input')) {
							this.setAddEventProp({
								prop: 'streetParkingAddress',
								value: location.provisions.inputs.street_parking_input
							})
						}
					}
					if (provisions.includes('paid_lot')) {
						this.setAddEventProp({ prop: 'paidLot', value: true })
						if (location.provisions.inputs.hasOwnProperty('paid_lot_address')) {
							this.setAddEventProp({
								prop: 'paidLotAddress',
								value: location.provisions.inputs.paid_lot_address
							})
						}
						if (location.provisions.inputs.hasOwnProperty('paid_lot_price')) {
							this.setAddEventProp({
								prop: 'paidLotPrice',
								value: location.provisions.inputs.paid_lot_price
							})
						}
					}
				}

				this.setAddEventProp({ prop: 'wrkprtyType', value: null })

				let validSteps = deepCopy(this.getAddEventProp('validSteps'))
				for (var i = 0; i < validSteps.length; i++) {
					if (
						validSteps[i] !== '/host/add/event' &&
						validSteps[i] !== '/host/add/event/' &&
						validSteps[i] !== '/host/add/event/location' &&
						validSteps[i] !== '/host/add/event/location/'
					) {
						this.setAddEventInvalidStep(validSteps[i])
						this.removeAddEventValidStep(validSteps[i])
					}
				}
			}
		},
		infoDialog: {
			get() {
				return this.getAddEventProp('infoDialog')
			},
			set(val) {
				this.setAddEventProp({ prop: 'infoDialog', value: val })
			}
		}
	}
}
</script>

<style>
</style>
